import React from "react";
import "./Industrial_domestic_softener.css";
import { Link } from "react-router-dom";  

export default function SoftenerPage() {
  return (
    <div className="softener-page">

      {/* Hero */}
      <section className="herosec" style={{ backgroundImage: "url('/images/IWSB.png')" }}
>
        <div className="herosec-overlay">
            <h1>Industrial & Domestic Water Softeners</h1>
            <p>Reliable solutions for scale-free, efficient water systems.</p>
           <Link to="/contact">
            <button className="btn-primary">Request a Quote</button></Link>
        </div>
      </section>

      {/* Description */}
      <section className="description section">
        <div className="description-content">
          <img
            src="/images/IWS.png"
            alt="Softener Unit"
            className="description-image"
          />
          <div className="description-text">
            <h2>Description</h2>
            <p>
              Crystal Drops offers Softener units designed for both industrial and domestic use.
              These units can be operated manually or automatically (optional).
              These Softeners are avialable with Mild Steel Rubber lined and Carbon Steel Epoxy Painted
              options and shall be selected based on inlet water characteristics.
            </p>
          </div>
        </div>
      </section>

      {/* Applications */}
      <section className="applications section">
        <h2>Applications</h2>
        <div className="applications-grid">
          {[
            "Boiler Feed Water",
            "Beverage Production",
            "Hospitals, Air Conditioning Plants",
            "Pre-treatment for RO Plants",
            "Domestic Water Supply",
          ].map((app, i) => (
            <div key={i} className="application-card">
              <img
                src={`/images/app-${i + 1}.png`}
                alt={app}
                className="application-image"
              />
              <p>{app}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Advantages */}
      <section className="advantages section">
        <h2>Advantages</h2>
        <ul>
          <li>
            <strong>Light weight</strong> – easy to install and comission.
          </li>
          <li>
            <strong>Low Maintenance cost</strong> – minimal upkeep required.
          </li>
          <li>
            <strong>User friendly to operate</strong> – it's simplified single Lever Multi-port valve design.
          </li>
          <li>
            <strong>Pre-assembled and tested before shipment</strong> – ensures quality and performance.
          </li>
        </ul>
      </section>

      {/* Technical Specifications */}
      <section className="specs section">
        <h2>Technical Specifications</h2>
        <p>Crystal Drops FRP / MS Softener Filter Consists of:</p>
        <ul>
          <li>FRP / MS Pressure Vessel</li>
          <li>Salt tank of HDPF/FRP with fittings</li>
          <li>Cation Exchange</li>
          <li>Ejector</li>
          <li>Hardness Test Kit</li>
          <li>Multiport/ Individual valve</li>
          <li>Sampling valve</li>
          <li>Associated Piping</li>
          <li>Pressure Indicators</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="cta">
        <h2>Ready for scale-free water?</h2>
        <div className="cta-buttons">
         <Link to="/contact">
          <button className="btn-primary">Get a Quote</button></Link>
          <a href="/Brochure.pdf" download className="btn-secondary">Download Brochure</a>
        </div>
      </section>
    </div>
  );
}